"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mount = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));
/**
 * Calls mount function with reference to dom node
 * and handles genericizing the navigation messaging
 */


exports.Mount = (0, react_1.memo)(function Mount(_a) {
  var navigator = _a.navigator,
      mount = _a.mount,
      pathname = _a.pathname,
      basename = _a.basename,
      reactiveMap = _a.reactiveMap,
      scopedMap = _a.scopedMap,
      className = _a.className,
      sliceName = _a.sliceName,
      sliceVersion = _a.sliceVersion;
  var ref = (0, react_1.useRef)(null);
  var initialPathname = (0, react_1.useRef)(pathname).current;
  (0, react_1.useEffect)(function () {
    var _a = mount(ref.current, {
      onSliceNavigate: function onSliceNavigate(nextPathname, _a) {
        var _b = _a === void 0 ? {} : _a,
            hash = _b.hash,
            search = _b.search;

        var _c = window.location,
            currentPathname = _c.pathname,
            currentHash = _c.hash,
            currentSearch = _c.search;

        if (currentPathname !== nextPathname || currentHash !== hash || currentSearch !== search) {
          navigator === null || navigator === void 0 ? void 0 : navigator.push({
            pathname: nextPathname,
            hash: hash,
            search: search
          });
        }
      },
      reactiveMap: reactiveMap,
      scopedMap: scopedMap,

      /**
       * If slice handles more than a single path it can not
       * reliably supply the current path name, so we pass the
       * currentPathName
       */
      pathname: initialPathname,
      basename: basename
    }),
        unmount = _a.unmount,
        onHostNavigate = _a.onHostNavigate;

    var unlisten = navigator === null || navigator === void 0 ? void 0 : navigator.listen(function (navigationEvent) {
      if (!onHostNavigate) return;
      var hash = navigationEvent.hash,
          search = navigationEvent.search;
      onHostNavigate(navigationEvent.pathname, {
        hash: hash,
        search: search
      });
    });
    return function () {
      unlisten === null || unlisten === void 0 ? void 0 : unlisten();
      unmount();
    };
  }, [mount, initialPathname, basename, navigator, reactiveMap, scopedMap]);
  return react_1.default.createElement("div", {
    ref: ref,
    className: className,
    "data-slice-name": sliceName,
    "data-slice-version": sliceVersion
  });
});